import styled from '@emotion/styled';

export const Container = styled.div`
  border: 2px solid white;
  position:relative;
  border-radius: 5px;
  width: 250px;
  height: 200px;
  padding: 20px 10px 20px 10px;
  margin-bottom: 30px;
  margin-right: 10px;
  background-image: url('/assets/images/formation-banner.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  > .head {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    color: white;
  }

  > .content {
    color: grey;
    font-size: 15px;
    font-family: Poppins-L;
  }

  &:hover {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 1), 0 6px 20px 0 rgba(0, 0, 0, 1);
    cursor: pointer;
  }
`;

export const FormationBox = ({
  title,
  body,
}: {
  title: string;
  body: string;
}) => {
  return (
    <Container>
      <h2 className='head'>{title}</h2>
      <div className='content'>{body}</div>
    </Container>
  );
};

